<template>
  <NuxtPage @submit="forwardSubmit" />
</template>

<script setup lang="ts">
import type { RouteLocationNormalized } from 'vue-router';

import { useBookingStore } from '~~/domains/booking';

type Emits = {
  (event: 'submit', step: string): void;
};

const emits = defineEmits<Emits>();

const bookingStore = useBookingStore();

definePageMeta({
  redirect(to: any) {
    return {
      params: { ridcode: to.params.ridcode },
      path: `/booking/${to.params.ridcode}/room`,
      query: to.query,
    };
  },
  validate(nextRoute) {
    return Boolean(nextRoute.params?.ridcode);
  },
});

const route = useRoute();
const ridcode = computed(() =>
  ((route.params.ridcode as string) ?? '').toUpperCase(),
);

function forwardSubmit(step: string) {
  emits('submit', step);
}

onMounted(() => {
  bookingStore.hotelId = ridcode.value;
});
</script>
